<div class="card">

</div>



// WEBPACK FOOTER //
// ./src/app/views/loyalty/widgets/points/valore-punti-redenti-indicator/valore-punti-redenti-indicator.component.html